import { AfterContentInit, Component, ElementRef, Input, NgZone, ViewChild, EventEmitter, Output, ContentChild, ContentChildren, QueryList, OnDestroy, AfterContentChecked } from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { ChartDropdownComponent } from "./cardContents/chartDropdown.component";
import { KpiHostMenuOptionComponent } from "./kpiHostMenuOption.component";
import { BaseComponent } from "../../common/baseComponent";

@Component({
    selector: 'kpi-host',
    templateUrl: './kpiHost.component.html',
    styleUrls: ['./kpiHost.component.css'],
    standalone: false
})
export class KpiHostComponent extends BaseComponent implements AfterContentInit, AfterContentChecked, OnDestroy {
    public hasMenu: boolean = false;
    public showMainDataHost: boolean = false;

    private cardMenuOptionsSubscriptions: Subscription[] = [];

    @Input() public kpiId: string = "";
    @Input() public kpiMenuId: string = "";
    @Input() public title: string = "";
    @Input() public tooltip: string = "";    
    @Input() public refreshing: boolean = false;
    @Input() public size: number = 1;
    @Input() public warn: boolean = false;
    @Input() public isMoreHost: boolean = false;
    @Input() public hostsMultiProgress: boolean = false;
    @Input() public hostsDoughnutChart: boolean = false;
    @Input() public hostsTable: boolean = false;
    @Input() public hostsLineChart: boolean = false;
    @Input() public hostsBarChart: boolean = false;
    @Input() public lastUpdatedText: string = "";
    @Input() public isTwoColumn: boolean = false;

    @Output() public detailRequested = new EventEmitter<any>();

    @ViewChild(NgbDropdown) private cardMenu: NgbDropdown;    
    @ViewChild("cardBody") private cardBody: ElementRef;
    @ViewChild("mainDataHost") private mainDataHost: ElementRef;

    @ContentChildren(KpiHostMenuOptionComponent) private cardMenuOptions: QueryList<KpiHostMenuOptionComponent>;
    @ContentChild(ChartDropdownComponent) private chartDropdown: ChartDropdownComponent;

    constructor(zone: NgZone) {
        super(zone);
    }

    public ngAfterContentInit(): void {
        if (this.mainDataHost) {
            this.showMainDataHost = this.mainDataHost.nativeElement.children.length > 0;
        }

        if (this.cardBody) {
            this.cardBody.nativeElement.style.cursor = this.detailRequested.observers.length > 0 ? "pointer" : "default";
        }

        this.hasMenu = this.cardMenuOptions.length > 0;
        this.cardMenuOptions.forEach((cardMenuOption) => {
            this.cardMenuOptionsSubscriptions.push(cardMenuOption.click.subscribe(() => this.cardMenu.close()));
        });
    }

    public ngAfterContentChecked(): void {
        if (this.mainDataHost) {
            this.showMainDataHost = this.mainDataHost.nativeElement.children.length > 0;
        }
    }

    public bodyClick(event: Event): void {
        if (!this.chartDropdown) {
            event.stopPropagation();
            this.detailRequested.emit(event);
        } else {
            if (!this.chartDropdown.isOpen) {
                this.detailRequested.emit(event);
            }
        }
    }

    public ngOnDestroy(): void {
        for (let subscription of this.cardMenuOptionsSubscriptions) {
            subscription.unsubscribe();
        }
    }

    public enableMenuAutoClose() {
        this.zone.run(() => { this.cardMenu.autoClose = true; });
    }

    public disableMenuAutoClose() {
        this.zone.run(() => { this.cardMenu.autoClose = false; });
    }

    public toggleMenu() {
        this.zone.run(() => this.cardMenu.toggle());
    }

    public openMenu() {
        this.zone.run(() => { this.cardMenu.open(); });
    }

    public closeMenu() {
        this.zone.run(() => this.cardMenu.close());
    }
}